import React from 'react'

import { IQuestionViewProps } from '../types'
import { FeedbackQuestionModelTypes, FeedbackResponse } from './types'

import Stars from '../StarRating/stars/Stars'
import useSurveyLocale from '../../modules/locale/useSurveyLocale'
import style from './style.module.scss'
import commonStyle from '../_common/style.module.scss'
import useViewport from '../../modules/viewport/useViewport'
import TextWithOptions from '../../modules/preview/components/TextWithOptions'
import usePreviewOptions from '../../modules/preview/usePreviewOptions'
import { InputTextarea } from 'primereact/inputtextarea'

const FeedbackView = ({
  schema,
  response,
  onUpdateResponse,
  showValidation,
  responseValidation
}: IQuestionViewProps<FeedbackQuestionModelTypes>) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  const previewOptions = usePreviewOptions()

  const onStarChange = (value: number) => {
    const updated: FeedbackResponse = {
      ...response,
      data: [{ ...response.data[0], value }]
    }
    onUpdateResponse(updated)
  }

  const onCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const updated: FeedbackResponse = {
      ...response,
      comment: e.target.value
    }
    onUpdateResponse(updated)
  }

  const starValue = response.data[0]?.value

  return (
    <fieldset
      className={`${style.feedbackView} ${
        viewport.mobile || (viewport.emulated && viewport.width <= 500) ? style.mobile : ''
      }`}
      data-testid="SW-FB"
    >
      <legend className={commonStyle.srOnly}>{t('questions', 'feedback', 'title')}</legend>
      <div
        className={`${commonStyle.answerBlock} ${style.answerBlock} ${
          showValidation && !responseValidation.valid ? style.error : ''
        }`}
      >
        <div className={style.answer}>
          <div className={style.title} data-testid="SW-FB-Title">
            <TextWithOptions text={t('questions', 'feedback', 'overall')} options={previewOptions} />
          </div>
          <div className={style.ratingBlock} data-testid="SW-FB-Stars">
            <Stars
              label={t('questions', 'feedback', 'overall')}
              value={starValue}
              size={schema.degree}
              index={0}
              onChange={onStarChange}
            />
          </div>
        </div>
      </div>
      <div className={style.commentRow}>
        <InputTextarea
          className={style.commentInput}
          placeholder={t('questions', 'feedback', 'comment')}
          value={response.comment || ''}
          onChange={onCommentChange}
          data-testid="SW-FB-Comment"
          rows={3}
        />
      </div>
    </fieldset>
  )
}

export default FeedbackView
